enum SearchState {
    STATE_CREATED = 0,
    STATE_STARTED = 1,
    STATE_DEPOT_IMPORTED = 2,
    STATE_DEPOT_PROCESSED = 3,
    STATE_CAR_IMPORTED = 4,
    STATE_CAR_PROCESSED = 5,
    STATE_CAR_EXPORTED = 6
}

export default SearchState;
